import { GuidedField } from '../../guidance/GuidedField';
import { fieldDef } from '../../guidance/roleFieldRegistry';
import { ReorderList } from '../guided/ReorderList';
import { LinesField, ReferenceMultiField, TextAreaField, TextField } from './fields';
import { useWizard } from './WizardContext';

const toItems = (text: string): string[] => (text ? text.split(/\r?\n/).filter((l) => l.trim() !== '') : []);

/**
 * Step 3: the essential duties and the additional responsibilities as two ordered lists (add, edit, remove, reorder, move between the two), with the
 * template's own statements offered as suggestions to add, then the other guided fields. Nothing generic is added for the person.
 */
export function ResponsibilitiesStep() {
  const w = useWizard();
  const f = w.form;
  const essential = toItems(f.essentialDuties);
  const additional = toItems(f.responsibilities);
  const source = w.suggestionTemplate ? `the ${w.suggestionTemplate.title} template` : undefined;

  return (
    <div className="jr-step jr-grid" data-testid="responsibilities-step">
      <div className="jr-grid__wide">
        <GuidedField field={fieldDef('essentialDuties')} error={w.errorOf('essentialDuties')}>
          {(a) => (
            <ReorderList
              a11y={a} noun="essential duty" items={essential} disabled={w.disabled}
              onChange={(items) => w.set('essentialDuties', items.join('\n'))}
              moveTo={{ label: 'Move to additional', onMove: (i) => w.setMany({ essentialDuties: essential.filter((_, n) => n !== i).join('\n'), responsibilities: [...additional, essential[i]!].join('\n') }) }}
              suggestions={w.suggestionTemplate?.content.essentialDuties ?? []} suggestionSource={source}
            />
          )}
        </GuidedField>
      </div>
      <div className="jr-grid__wide">
        <GuidedField field={fieldDef('responsibilities')} error={w.errorOf('responsibilities')}>
          {(a) => (
            <ReorderList
              a11y={a} noun="additional responsibility" items={additional} disabled={w.disabled}
              onChange={(items) => w.set('responsibilities', items.join('\n'))}
              moveTo={{ label: 'Move to essential', onMove: (i) => w.setMany({ responsibilities: additional.filter((_, n) => n !== i).join('\n'), essentialDuties: [...essential, additional[i]!].join('\n') }) }}
              suggestions={w.suggestionTemplate?.content.responsibilities ?? []} suggestionSource={source}
            />
          )}
        </GuidedField>
      </div>
      <LinesField k="expectedOutcomes" isWide />
      <TextAreaField k="decisionAuthority" />
      <TextAreaField k="budgetAuthority" />
      <TextAreaField k="supervisoryResponsibilities" />
      <TextAreaField k="internalRelationships" />
      <TextAreaField k="externalRelationships" />
      <LinesField k="complianceResponsibilities" />
      <ReferenceMultiField k="performanceIndicators" noun="indicator" isWide />
      <TextField k="reportsTo" />
    </div>
  );
}
